import { Loader2 } from "lucide-react";

/**
 * Lightweight route-transition loader.
 * Shows a compact centred spinner rather than a full branded splash
 * to reduce perceived jank during lazy-loaded route changes.
 */
const LoadingScreen = () => {
  return (
    <div className="flex items-center justify-center py-32 min-h-[50vh]">
      <Loader2 className="h-6 w-6 animate-spin text-primary" aria-label="Loading page" />
    </div>
  );
};

export default LoadingScreen;
